import { memo } from "react";
import { GenericIcon } from "@ppb/the-wall-icons/GenericIcon/GenericIcon";
import { SystemIconName } from "@ppb/the-wall-icons";

export const NotificationsIcon = memo(({ unreadNotifications }: { unreadNotifications: boolean }) => (
  <GenericIcon
    name={unreadNotifications ? SystemIconName.MESSAGE_UNREAD : SystemIconName.MESSAGE_READ}
    color="var(--header-icon-profile-icon-colour)"
  />
));

NotificationsIcon.displayName = "NotificationsIcon";
